class SizeOption extends BaseOption {

    constructor(container) {
        super(container);
        
        if (!container.length) return;
        
        this.images = this.container.find('.pc-option-size__image');
        this.unitSwitcherItem = this.container.find('.unit-switcher-item');
        this.currentUnit = 'mm';
        this.orientationSwitcherItem = this.container.find('.orientation-switcher-item');
         
        this.initAdditionalEvents();
    }

    initAdditionalEvents() {
        if (this.unitSwitcherItem && this.unitSwitcherItem.length) {
            this.handleUnitSwitch();
        }
        this.handleOrientationSwitch();
    }

    bindEvents() {
        super.bindEvents();
    }

    onValueSelect(value, index) {
        super.onValueSelect(value, index);
        this.setActiveImage(index);

        let option_orientation = this.getCurrentOrientation(value);

        /* if (option_orientation === 'landscape') {
            const activeImage = this.images.filter('.active');
            const $imageContainer = activeImage.find('.image-container');
            $imageContainer.addClass('landscape');
            activeImage.addClass('landscape-active');
        } */
        this.setOrientation(option_orientation);
        
        $(document).trigger('option-changed', [value.data('value')]);
    }

    getCurrentOrientation(selected_option) {
        let option_orientation = selected_option
            .closest('.pc-option-size__values')
            .siblings('.pc-option-size__images')
            .find('.pc-option-size__image.active')
            .find('.orientation-switcher-item.active')
            .data('orientation');

        return option_orientation;
    }

    handleUnitSwitch() {
        this.unitSwitcherItem.on('click', (e) => {
            const unit = $(e.currentTarget).data('unit');
            if (unit) {
                this.setActiveUnit(unit);
                this.updateDimensions();
            }
        });
    }

    handleOrientationSwitch() {
        this.orientationSwitcherItem.on('click', (e) => {
            const orientation = $(e.currentTarget).data('orientation');
            if (orientation) {
                this.setOrientation(orientation);
            }
        });
    }

    setActiveImage(index) {
        if (!this.images || !this.images.length) return;

        const currentOrientation = this.currentOrientation;
        
        this.images.removeClass('active landscape-active')
            .find('.image-container').removeClass('landscape');
        
        const newActiveImage = this.images.filter(`[data-index="${index}"]`);
        newActiveImage.addClass('active');
        
        if (currentOrientation === 'landscape') {
            newActiveImage.addClass('landscape-active')
                .find('.image-container').addClass('landscape');
        }
    }

    setActiveUnit(unit) {
        if (!this.unitSwitcherItem || !this.unitSwitcherItem.length) return;

        this.currentUnit = unit;
        this.unitSwitcherItem
            .filter(`[data-unit="${unit}"]`)
            .addClass('active')
            .siblings()
            .removeClass('active');
    }

    setOrientation(orientation) {
        
        const activeImage = this.images.filter('.active');
        const defaultOrientation = activeImage.data('orientation');
        const $imageContainer = activeImage.find('.image-container');

        activeImage.find('.orientation-switcher-item[data-orientation="' + orientation + '"]')
            .addClass('active')
            .siblings()
            .removeClass('active');

        if(orientation === defaultOrientation) {
            $imageContainer.height('100%');
            $imageContainer.removeClass('rotate-90');
        }else{
            let width = $imageContainer.width();
            $imageContainer.height(width);
            $imageContainer.addClass('rotate-90');
        }

        /* if (orientation === 'landscape') {
            $imageContainer.addClass('landscape');
            activeImage.addClass('landscape-active');
        } else {
            $imageContainer.removeClass('landscape');
            activeImage.removeClass('landscape-active');
        } */

        this.updateDimensions();
    }

    updateDimensions() {
        if (!this.images || !this.images.length) return;

        this.images.each((index, image) => {
            const $image = jQuery(image);
            const width = parseFloat($image.data('width'));
            const height = parseFloat($image.data('height'));

            if (!isNaN(width) && !isNaN(height)) {
                const convertedValues = this.convertDimensions(width, height, this.currentUnit);
                this.updateDimensionDisplay($image, convertedValues);
            }
        });
    }

    convertDimensions(width, height, unit) {
        return {
            width: this.convertValue(width, unit),
            height: this.convertValue(height, unit)
        };
    }

    convertValue(value, unit) {
        if (isNaN(value)) return 0;

        switch(unit) {
            case 'cm':
                return Math.round((value / 10) * 100) / 100;
            case 'in': 
                return Math.round((value / 25.4) * 100) / 100;
            default:
                return value;
        }
    }

    updateDimensionDisplay($image, { width, height }) {
        const $widthElement = $image.find('.width-value span');
        const $heightElement = $image.find('.height-value span');

        if ($widthElement.length) {
            $widthElement.text(`${width} ${this.currentUnit}`);
        }
        
        if ($heightElement.length) {
            $heightElement.text(`${height} ${this.currentUnit}`);
        }
    }
}